import React from "react";
import styles from "./FAQ.module.css";
import Section from "../Section/Section";
import FAQItem from "./FAQItem";

const FAQ = () => {
  const faqForm = [
    {
      title: "Got a question?",
      cards: [
        {
          icon: "➕",
          title: "FAQs Form",
          description: "Form to submit your questions regarding ClickUp links",
          link: "https://forms.clickup.com/90132059689/f/2ky4m5h9-4313/7YZKFZ5N7IDS67P8WY",
        },
      ],
    },
  ];

  return (
    <section className={styles.container}>
      <h1 className={styles.title}>Frequently Asked Questions</h1>
      <p className={styles.intro}>
        Quick answers to common questions. Have more? Reach out to the team.
      </p>
      <div className={styles.faqList}>
        <FAQItem question="How do I submit an event?">
          <p>
            You can submit an event by visiting{" "}
            <a href="/clickup-links/?selectedElementName=Requesting%20an%20Event" target="_blank" rel="noopener noreferrer">
              Clickup Link pages{" "}
            </a>
            and clicking on the Request Form button.
          </p>
          <p>
            Fill out the form with all the necessary details — including the
            Start Date and Time fields at the bottom of the dialog box. Once you
            submit the form, you’ll receive an acknowledgment notification
            confirming your submission. 
          </p>
        </FAQItem>

        <FAQItem question="How can I edit an event after submission?">
          <p>
            If you need to make changes to an event, please contact{" "}
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=cpb26@njit.edu&su=Edit%20in%20%5Bevent%5D" target="_blank" rel="noopener noreferrer">
              Carolina.
            </a>{" "}
            She will make the necessary edits on your behalf. After the update
            is made, you will receive an email notification confirming the
            changes.
          </p>
        </FAQItem>

        <FAQItem question="What is the workflow of the event status?">
          <p>
            Each event follows a defined status workflow:
            <ul>
              <li>
                <strong style={{background: "rgb(123, 123, 123)", color: "white"}}>REQUESTED</strong> When the event request is first
                submitted.
              </li>
              <li style={{marginTop: "0.4em"}}>
                <strong style={{background: "rgb(255, 197, 61)", color: "black"}}>PROCESSING</strong> When the Operations Team begins
                working on the event.
              </li>
              <li style={{marginTop: "0.4em"}}>
                <strong style={{ background: "rgb(158, 73, 171)", color: "white"}}>READY FOR EXECUTION</strong> When all preparations are
                completed.
              </li>
              <li style={{marginTop: "0.4em"}}>
                <strong style={{ background: "rgb(18, 118, 226)", color: "white"}}>HAPPENING TODAY</strong> When the event is taking place
                on the current day.
              </li>
              <li style={{marginTop: "0.4em"}}>
                <strong style={{ background: "rgb(44, 140, 94)", color: "white"}}>COMPLETED</strong> When the event has finished
                successfully.
              </li>
              <li style={{marginTop: "0.4em"}}>
                <strong style={{ background: "rgb(210, 30, 36)", color: "white"}}>CANCELED</strong> When the event is canceled.
              </li>
            </ul>
            You can track the status of your event in the{" "}
            <a href="https://sharing.clickup.com/90132059689/l/h/6-901316860692-1/8f7544b0b5d9241" target="_blank" rel="noopener noreferrer">
              Event List By Status
            </a>{" "}
            view.
          </p>
        </FAQItem>

        <FAQItem question="How will I be notified about updates to my event?">
          <p>
            You will receive automated notifications via email for all major
            updates to your event. These notifications may appear to come from
            Carolina’s email, but they are automatically generated by ClickUp,
            not sent manually.
          </p>
          <p>
            Updates are also reflected in the comments section of your event’s
            ClickUp page. 
          </p>
        </FAQItem>

        <FAQItem question="Who receives event updates?">
          <p>
            Only the event contact person receives the event submission
            acknowledgment and subsequent update notifications. Support staff do
            not receive event updates.{" "}
          </p>
        </FAQItem>
      </div>
      {faqForm.map((section, index) => (
        <Section key={index} title={section.title} cards={section.cards} />
      ))}
    </section>
  );
};

export default FAQ;
